import { render } from "./daygrid-year.view.vue?vue&type=template&id=422e0b3a&scoped=true"
import script from "./daygrid-year.view.vue?vue&type=script&lang=js"
export * from "./daygrid-year.view.vue?vue&type=script&lang=js"

import "./daygrid-year.view.vue?vue&type=style&index=0&id=422e0b3a&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422e0b3a"]])

export default __exports__